export const messagesApi = {
    pt: {
        message:{
            active: "Ativas",
            apiRegistration: "Registro da API",
            clientId: "Client Id",
            clientSecret: "Client Secret",
            conclude: "Concluir",
            documentation: "Documentação",
            newApi: "Nova API",
            registerApi: "Cadastrar API",
            revocationDate: "Data de Revogação",
            revoke: "Revogar",
            revokeApi: "Revogar API",
            revokeApiConfirmation: "Você tem certeza que deseja revogar essa API?",
            revoked: "Revogadas"


        }
    },
    es: {
        message:{
            active:"Activo",
            apiRegistration:"Registro de API",
            clientId:"Identificación del cliente",
            clientSecret:"Secreto del cliente",
            conclude:"Concluir",
            documentation:"Documentación",
            newApi:"Nueva API",
            registerApi:"Registrar la API",
            revocationDate:"Fecha de revocación",
            revoke:"Revocar",
            revokeApi:"Revocar API",
            revokeApiConfirmation:"¿Estás seguro de que quieres revocar esta API?",
            revoked:"Revocado"
        }
    },
    en: {
        message:{
            active: "Actives",
            apiRegistration: "API registration",
            clientId: "Client Id",
            clientSecret: "Client Secret",
            conclude: "Conclude",
            documentation: "Documentation",
            newApi: "New API",
            registerApi: "Register API",
            revocationDate: "Revocation Date",
            revoke: "Revoke",
            revokeApi: "Revoke API",
            revokeApiConfirmation: "Are you sure you want to revoke this API?",
            revoked: "Revoked"



        }
    }
}
